export default function checkScrollToSiteInTopic(topic) {
  const {
    content,
    infinityIndex,
  } = topic;

  if (infinityIndex || process.env.NODE_ENV === 'test') return false;

  return Boolean(content?.relationships?.scroll_to_site?.data);
}
